"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpinnerStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var Spinner_1 = require("./Spinner");
exports.useSpinnerStyles = (0, styles_1.makeStyles)(function () {
    var _a;
    return (_a = {},
        _a[Spinner_1.SpinnerAlignment.Centered] = {
            display: 'flex',
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            fill: 'red',
        },
        _a);
});
